import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children"],
  _excluded2 = ["children", "className"],
  _excluded3 = ["children", "className"],
  _excluded4 = ["isBlock", "url", "title", "author", "children", "overwrites"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import pt from 'prop-types';
import { Paragraph, Element, Text } from '../';
import { extendProps, appendHtmlClass, getOverwrites } from '../../js/util';
import './_index.scss';
var Footer = function Footer(_ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Element, Object.assign({
    as: "footer"
  }, rest), children);
};
var Author = function Author(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  className = appendHtmlClass(className, 'author');
  return /*#__PURE__*/React.createElement(Element, Object.assign({
    as: "span",
    className: className
  }, rest), children);
};
var Title = function Title(_ref3) {
  var children = _ref3.children,
    className = _ref3.className,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  className = appendHtmlClass(className, 'title');
  return /*#__PURE__*/React.createElement(Element, Object.assign({
    as: "cite",
    className: className
  }, rest), children);
};
var Quote = function Quote(props) {
  var isBlock = props.isBlock,
    url = props.url,
    title = props.title,
    author = props.author,
    children = props.children,
    overwrites = props.overwrites,
    rest = _objectWithoutPropertiesLoose(props, _excluded4);
  var el = 'q';
  var attrs = _objectSpread({}, rest);
  if (url) attrs.cite = url;
  if (isBlock) {
    el = 'blockquote';
    var footer = null;
    var footerProps = getOverwrites(overwrites, 'Footer');
    var titleProps = getOverwrites(overwrites, 'Title');
    var authorProps = getOverwrites(overwrites, 'Author');
    var paragraphProps = getOverwrites(overwrites, 'Paragraph');
    if (author || title) {
      if (author) author = /*#__PURE__*/React.createElement(Author, authorProps, author);
      title = title ? /*#__PURE__*/React.createElement(Title, titleProps, title) : null;
      footer = /*#__PURE__*/React.createElement(Footer, footerProps, author, title);
    }
    children = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paragraph, paragraphProps, children), footer);
  }
  return /*#__PURE__*/React.createElement(Text, Object.assign({
    as: el
  }, attrs), children);
};
Object.assign(Quote, extendProps(Text, ['align', 'className', 'id', 'children', 'color', 'style'], {
  /**
   * Is it block quote, e.i. use <blockquote> instead of <q>?
   */
  isBlock: pt.bool,
  /**
   * Url to citation source
   */
  url: pt.string,
  /**
   * Citation title e.g. 'Brave New World', relevant only if isBlock equals true
   */
  title: pt.node,
  /**
   * Citation author e.g. George Orwell, relevant only if isBlock equals true
   */
  author: pt.node,
  /**
   * Overwrites child elements
   */

  overwrites: pt.shape({
    Footer: pt.object,
    Paragraph: pt.object,
    Author: pt.object,
    Title: pt.object
  })
}, {
  isBlock: false
}));
export default Quote;